import React from "react";
import GoogleFormWrapper from "../../../../../../shared_components/GoogleFormWrapper";
import { BsCheck2Circle } from "react-icons/bs";
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

const Form = ({ model,
  toggle,
  modelTitle,
  modelDescription,
  sessionTitle,
  success,
  onSuccess
}) => {

  const reasons = [
    "I want to transition into tech career",
    "I want to enhance my coding skills",
    "I want to grow in my current tech role",
    "I want to build my own tech startup",
    "I'm curious about coding and want to learn",
    "It's required for my current/future job",
    "I want to learn coding as a hobby",
    "I'm a student looking to start my tech journey",
    "Other",
  ];

  return (
    <Modal
      centered
      isOpen={model}
      toggle={toggle}
      size="lg"
      className="google-form-modal"
    >
      <ModalHeader
        toggle={toggle}
        className="border-0 pb-0"
      ></ModalHeader>
      <ModalBody className="text-center px-md-5 px-4">
        <div className="bg-light p-4 mb-md-4 mb-3 border radius-10">
          <h4 className="mb-2 font-weight-bold">{modelTitle}</h4>
          <p className="text-muted mb-0 fs-14">{modelDescription}</p>
          <h1 className="mt-3 font-weight-bold">{sessionTitle?.heading}</h1>
          <h5 className="text-muted fs-18">{sessionTitle?.time}</h5>
        </div>
        {/* Inject your form or content here */}
        <div className="modal-form">
          <div className="text-center">
            <>
              {success ? (
                <div className="text-center border p-5 rounded-lg">
                  <BsCheck2Circle className="mb-5 text-success" size={100} />
                  <div className="alert alert-success" role="alert">
                    Thank you! We'll get back to you shortly.
                  </div>
                </div>
              ) :
                <GoogleFormWrapper
                  fields={[
                    {
                      label: 'Your Name',
                      name: 'entry.578351606', // Replace with actual Google Form entry ID
                      fieldName: 'name',
                      placeholder: 'Enter your name',
                      required: true,
                      type: 'text',
                    },
                    {
                      label: 'Your Email',
                      name: 'entry.826426055',
                      fieldName: 'email',
                      placeholder: 'Enter your email',
                      required: true,
                      type: 'email',
                    },
                    {
                      label: 'Your Phone Number',
                      name: 'entry.1554792534',
                      fieldName: 'phone',
                      placeholder: 'Enter your phone number',
                      required: true,
                      type: 'text',
                    },
                    {
                      label: 'Your Gender',
                      name: 'entry.978076410',
                      fieldName: "gender",
                      options: ['Male', 'Female', 'Other'],
                      required: true,
                      type: 'radio',
                    },
                    {
                      label: 'Your College',
                      name: 'entry.2121190026',
                      fieldName: 'college',
                      placeholder: 'Enter your College',
                      required: true,
                      type: 'text',
                    },
                    {
                      label: 'Preferred Class',
                      name: 'entry.1574793469', // Replace with actual Google Form entry ID
                      fieldName: 'preferredClass',
                      placeholder: `${sessionTitle?.heading} - ${sessionTitle?.time}`,
                      required: false,
                      type: 'text',
                      disabled: true,
                    },
                    {
                      label: 'Passout Year',
                      name: 'entry.1741450239',
                      fieldName: 'passoutYear',
                      placeholder: 'Enter your Batch',
                      required: true,
                      type: 'text',
                    },
                    {
                      label: 'Why do you want to join this free code class?',
                      name: 'entry.619625282',
                      fieldName: 'reason',
                      placeholder: 'Write your reason',
                      required: true,
                      type: 'text',
                    },
                  ]}
                  btnName="Book Now"
                  formId="1FAIpQLScSP20Wjc4KnIsUFoFWDkn9OrHbKXzi8k1snxpc_g6qWkguQw"
                  redirectToWhatsApp={true}
                  whatsappNumber="7400898402"
                  defaultFields={{
                    "entry.1574793469": `${sessionTitle?.heading} - ${sessionTitle?.time}`,
                    "entry.2001895594": `Not Joined`
                  }}
                  onSuccess={onSuccess}
                  toggleModal={toggle}
                />
              }
            </>
          </div>
        </div>
      </ModalBody>
    </Modal>

  );
};
export default Form;
